import { Decorative } from "@faire/design-tokens";
import { getIsApparelRetailer } from "@faire/retailer-visitor-shared/serialized-data/getIsApparelRetailer";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import flashSale from "@faire/web-api--source/routes/www/flash-sale";
import { observer } from "mobx-react";
import * as React from "react";
import type { JSX } from "react";
import styled from "styled-components";

const TabletAndAboveBanner = () => {
  return (
    <>
      <StrictLocalMsg
        defaultMessage="<MediumFormatting>Shop our Warehouse Sale!</MediumFormatting> Enjoy 60% off unique finds <DashFormatting> ends Friday.</DashFormatting> <LinkFormatting>Shop now</LinkFormatting>"
        description={{
          text: "Nudge to let retailers know the seasonal warehouse sale is currently active",
          img: "https://cdn.faire.com/fastly/5de14755044e39a50cef145e3caff51d8921ff4ffa24ec78ff91d384146bf07f.png",
        }}
        values={{
          MediumFormatting,
          LinkFormatting,
          DashFormatting,
        }}
      />
    </>
  );
};

const MobileBanner = () => {
  return (
    <StrictLocalMsg
      defaultMessage="<MediumFormatting>Enjoy 60% off until Friday!</MediumFormatting> <LinkFormatting>Shop Warehouse Sale</LinkFormatting>"
      description={{
        text: "Nudge to let retailers know the seasonal warehouse sale is currently active",
      }}
      values={{
        MediumFormatting,
        LinkFormatting,
      }}
    />
  );
};

const WarehouseSaleBannerBase: React.FC = () => {
  return (
    <BannerWrapper>
      <Typography align="center">
        <ResponsiveContentV2
          mobile={<MobileBanner />}
          tabletAndAbove={<TabletAndAboveBanner />}
        />
      </Typography>
    </BannerWrapper>
  );
};

const BannerWrapper = styled(Row).attrs({
  justify: "center",
  align: "center",
})`
  background-color: ${Decorative.tint.neutral};
  width: 100%;
  height: 36px;
`;

const DashFormatting = (chunk: JSX.Element) => <>&#8212;{chunk}</>;
const LinkFormatting = (chunk: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={
      getIsApparelRetailer()
        ? flashSale({
            "seasonal-warehouse-sales": "1",
            filters: "category:apparel",
          })
        : flashSale({ "seasonal-warehouse-sales": "1" })
    }
  >
    {chunk}
  </Button>
);

export const WarehouseSaleBanner = observer(WarehouseSaleBannerBase);
